const BLUX_DEVICE_ID = "blux_deviceId";
const BLUX_URL = "blux_url";
const BLUX_REF = "blux_ref";
const BLUX_INAPP_HIDE_TIMESTAMP = "blux_inapp";

export class LocalStorage {
  static getDeviceId(): string | null {
    const deviceId = localStorage.getItem(BLUX_DEVICE_ID);
    return deviceId === "undefined" || deviceId?.trim() === ""
      ? null
      : deviceId;
  }

  static setDeviceId(deviceId: string) {
    localStorage.setItem(BLUX_DEVICE_ID, deviceId);
  }

  static getUrl(): string | null {
    const url = localStorage.getItem(BLUX_URL);
    return url === "undefined" || url?.trim() === "" ? null : url;
  }

  static setUrl(url: string) {
    localStorage.setItem(BLUX_URL, url);
  }

  static getRef(): string | null {
    const ref = localStorage.getItem(BLUX_REF);
    return ref === "undefined" || ref?.trim() === "" ? null : ref;
  }

  static setRef(ref: string) {
    localStorage.setItem(BLUX_REF, ref);
  }

  static setInappHideTimestamp(key: string, timestamp: number) {
    localStorage.setItem(
      `${BLUX_INAPP_HIDE_TIMESTAMP}/${key}`,
      timestamp.toString(),
    );
  }

  static getInappHideTimestamp(key: string): number | null {
    const timestamp = localStorage.getItem(
      `${BLUX_INAPP_HIDE_TIMESTAMP}/${key}`,
    );
    return timestamp ? parseInt(timestamp) : null;
  }
}
